module.exports = __webpack_public_path__ + "static/media/bn.85144858.svg";